import React, { useEffect, useState } from 'react';
import TablePagination from '@material-ui/core/TablePagination';

export default function Paginacao(props) {
    const {
        rowsPerPage,
        setRowsPerPage,
        totalRows,
        onChangePage,
        rowsPerPageOptions,
        firstLoad,
    } = props;

    const [page, setPage] = useState(0);
    // const [rowsPerPage, setRowsPerPage] = useState(startingRowsPerPage);

    useEffect(() => {
        if (firstLoad) {
            setPage(0);
        }
    }, [firstLoad])
    const handleChangePage = (event, newPage) => {
        const pageFrom = newPage * rowsPerPage;
        onChangePage(pageFrom);
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <TablePagination
            component='div'
            count={parseInt(totalRows)}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={rowsPerPageOptions ? rowsPerPageOptions : []}
            labelRowsPerPage='Registros por página'
            labelDisplayedRows={({ from, to, count }) => `Mostrando ${from}-${to} de ${count}`}
        />
    );
}
